import { useEffect, useRef } from 'react';

import { ACADEMIC_TYPE } from '@common/type/CourseTypes';

import useCourseDetail from '../useCourseDetail';
import useCourseEnrollment from '../useCourseEnrollment';

import { createGoogleAnalyticItem, sendPageViewContentCourseDetail } from '@helpers/googleTagManager';
import { RegularCourseEnrollmentStatus } from '@redux/course/type/courseDetailType';

const useCourseRegularBanner = () => {
  const { name, price, courseDetailData, bannerPrimaryColor, bannerSecondaryColor } = useCourseDetail();
  const { courseEnrollmentStatus } = useCourseEnrollment();
  const isSendGtmEvent = useRef<boolean>(false);
  const isUnPurchase = [RegularCourseEnrollmentStatus.UNPUBLISHED, RegularCourseEnrollmentStatus.PUBLISHED].includes(
    courseEnrollmentStatus as RegularCourseEnrollmentStatus,
  );

  const isEnrolled = RegularCourseEnrollmentStatus.ENROLLED === courseEnrollmentStatus;

  const getGa4Item = () => {
    return [
      createGoogleAnalyticItem({
        courseDetail: courseDetailData,
        academicType: ACADEMIC_TYPE.REGULAR,
        courseName: name,
      }),
    ];
  };

  useEffect(() => {
    if (isUnPurchase || isEnrolled || isSendGtmEvent.current || !courseDetailData) return;

    const ga4Items = getGa4Item();

    if (!ga4Items) return;

    isSendGtmEvent.current = true;

    const value = ga4Items[0].price;

    sendPageViewContentCourseDetail({
      currency: 'THB',
      value,
      items: ga4Items,
    });
  }, [isUnPurchase, isEnrolled, courseDetailData]);

  return {
    isEnrolled,
    courseEnrollmentStatus,
    courseDetailData,
    name,
    price,
    bannerPrimaryColor,
    bannerSecondaryColor,
  };
};

export default useCourseRegularBanner;
